import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export function useUserInfo() {
  const page = usePage();
  const user = computed(() => page.props.auth.user);
  return { user };
}
